import { IconButton, type IconButtonProps } from '@chakra-ui/react'
import { CloseIcon } from '../assets/icons'

export const CloseIconButton = ({ iconSize = '20px', ...props }: IconButtonProps & { iconSize?: string }) => {
  return (
    <IconButton border='none' isRound size='sm' _focus={{ border: 'none' }} _hover={{ border: 'none' }} {...props}>
      <CloseIcon height={iconSize} width={iconSize} color='#848484' cursor='pointer' />
    </IconButton>
  )
}
